import React, { Fragment, useState } from 'react';
import { DAM_SVG } from '../DamAssets';

const CommonThreeDotSvg = () => {
  return (
    <Fragment>
      <div
        className="hovered_ellipses d-flex align-items-center text-center justify-content-center"
        style={{ cursor: 'pointer', width: '30px' ,
          height:"30px",
        }}
      >
        {DAM_SVG.threeDotSvgWithoutPadding}
      </div>
    </Fragment>
  );
};

export default CommonThreeDotSvg;
